import csiAction from "csi/action";
import ActionViewConstructor, { ActionView } from "csi/action/ActionView";
import StateActionController from "csi/breadcrumb/StateActionController";
import def from "csi/def";
import Action from "csi/def/Action";
import Request from "csi/def/Request";
import { ViewRef } from "csi/def/ViewRef";
import { FormView } from "csi/form/View";
import locale from "csi/locale";
import reflection from "csi/reflection";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const ApproveConfirmController = declare(StateActionController, {

	/**
	 * @override
	 * Return ActionView for form
	 */
	getActionView(vr: ViewRef): ActionView {
		const rc = reflection.getClass("_CS_Revision");
		const defView = def.getClassViewDef(rc, "ApproveConfirmForm") as FormView;
		defView.getField("RevisionComment").bForceEditable = true;
		return new ActionViewConstructor(this, defView);
	},

	/**
	 * @override
	 * Return title for popup view
	 */
	getTitle(): string {
		return locale.tooltip(this.m_action.m_id);
	},

	/**
	 * @override
	 * Return string used as introduction to popup dialog
	 */
	getIntroString(): string {
		const parent = this.getNode()?.__Parent__;
		const type = this.getCache().getNode(parent).$Type;
		return locale.resource(this.m_action.m_id + csiAction.SUFFIX_DETAIL, [locale.typePlural(type)]);
	},

	/**
	 * @override
	 * Publish revision comment
	 */
	toWriter(): void {
		const fd = this.getFormData();
		const comment = fd.getFieldValue("RevisionComment");

		this.m_writer.changeNode(this.getNode().$URL)
			.changeAttribute("RevisionComment", xml.ATTR_STRING, comment);

		this.inherited(arguments);
	},

	/**
	 * @override
	 * Invoke MassUpdateDataSheets action after ApproveConfirm action if not on first revision
	 */
	postProcessSuccess(): void {
		const firstRevisionURL = this.getParent().Revisions.first();
		if (this.getNodeURL() !== firstRevisionURL) {
			const action = Object.assign(new Action(), {
				classController: "csi/breadcrumb/MassUpdateDataSheetsController",
				m_id: "MassUpdateDataSheets",
				m_postAction: "postActionRedrawNode",
				m_rcTarget: reflection.getClass(this.getNode().$Type),
				m_request: Object.assign(new Request(), {
					m_module: "SiteAdmin",
					m_operation: "MassUpdateDataSheets",
				}),
			});
	
			csiAction.invoke(this.widget, null, action, { bRefreshRevision: true });
		} else {
			this.inherited(arguments);
		}
	},
});

export = ApproveConfirmController;